import { Badge } from "antd";
import {
  candidatesStatusList,
  candidateStatusOption,
} from "../help-service/enumList";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";
import { fileTypes } from "../constants/constants";

export const renderCandidateStatus = (status) => {
  switch (status) {
    case 1:
      return <Badge className="badge-r1">R1</Badge>;
    case 2:
      return <Badge className="badge-s">S</Badge>;
    case 3:
      return <Badge className="badge-sh">SH</Badge>;
    case 4:
      return <Badge className="badge-re">NS</Badge>;
    case 5:
      return <Badge className="badge-oh">OH</Badge>;
    case 6:
      return <Badge className="badge-ns">NS</Badge>;
    case 7:
      return <Badge className="badge-w">W</Badge>;
    case 8:
      return <Badge className="badge-ps">PS</Badge>;
    case 9:
      return <Badge className="badge-rs">RS</Badge>;
    case 10:
      return <Badge className="badge-j">J</Badge>;
    default:
      break;
  }
  return;
};

export const renderInterviewStatus = (status) => {
  switch (status) {
    case 1:
      return <div className="badge-r1 interview-status-badge">Round-1</div>;
    case 2:
      return <div className="badge-s interview-status-badge">Selected</div>;
    case 3:
      return <div className="badge-sh interview-status-badge">Shortlisted</div>;
    case 4:
      return (
        <div className="badge-re interview-status-badge">Not Selected</div>
      );
    case 5:
      return <div className="badge-oh interview-status-badge">On hold</div>;
    case 6:
      return <div className="badge-ns interview-status-badge">No show</div>;
    case 7:
      return (
        <div className="badge-w interview-status-badge">Withdraw candidate</div>
      );
    case 8:
      return (
        <div className="badge-ps interview-status-badge">Pre screened</div>
      );
    case 9:
      return <div className="badge-rs interview-status-badge">Rescheduled</div>;
    case 10:
      return <div className="badge-j interview-status-badge">Joined</div>;
    default:
      break;
  }
  return;
};

export const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, "0"); // Ensure 2 digits for the day
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear(); // Get the full year
  return `${day}-${month}-${year}`;
};

export const formatNumber = (number) => {
  return new Intl.NumberFormat("en-IN").format(number);
};

export const isFilterEmpty = (obj) => {
  return Object.entries(obj).every(([key, val]) => {
    if (key === "searchText") {
      return !val || val.trim() === "";
    }

    if (Array.isArray(val)) {
      return val.length === 0;
    }

    return val == null;
  });
};

export const formatToLPA = (value) => (value / 100000).toFixed(2);

export const calculateRange = (years, months) => {
  const startYear = years;
  const endYear = months > 0 ? years + 1 : years;
  return `${startYear} - ${endYear} years`;
};

export const getTokenInCookies = async () => {
  const cookies = document.cookie.split("; ");
  const tokenCookie = cookies.find((row) => row.startsWith("token="));

  if (!tokenCookie) {
    console.error("Token not found in cookies");
    return null;
  }

  return tokenCookie.split("=")[1];
};

export const renderCandidateFeedbackStatus = (status) => (
  <div
    style={{
      display: "inline-block",
      padding: "3px 8px",
      borderRadius: "20px",
      fontSize: "12px",
      backgroundColor:
        candidatesStatusList.statusBadge[status]?.background || "#fff",
      color: candidatesStatusList.statusBadge[status]?.borderText || "#000",
      border: `1px solid ${
        candidatesStatusList.statusBadge[status]?.borderText || "#000"
      }`,
    }}
  >
    {candidateStatusOption.emailtext[status] || "Unknown"}
  </div>
);

export const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    const exp = decoded.exp;
    const now = Date.now() / 1000;
    return now >= exp;
  } catch (e) {
    return true;
  }
};

export const parsePossibleDate = (input) => {
  const dateFormats = [
    "DD-MM-YYYY",
    "YYYY-MM-DD",
    "MM-DD-YYYY",
    "DD/MM/YYYY",
    "MM/DD/YYYY",
    "YYYY/MM/DD",
    "D MMM YYYY",
    "MMMM D, YYYY",
  ];
  for (const format of dateFormats) {
    const parsed = dayjs(input, format, true); // strict mode
    if (parsed.isValid()) return parsed;
  }

  // Fallback to native Date parse
  const fallback = dayjs(new Date(input));
  return fallback.isValid() ? fallback : null;
};

export const normalizeQuillValue = (value) => {
  if (!value) return "";

  const isEmpty = value.replace(/<(.|\n)*?>/g, "").trim().length === 0;
  return isEmpty ? "" : value;
};

export const getFileType = (fileName) => {
  if (!fileName) return "";
  const ext = fileName.split(".").pop().toLowerCase(); // get last part after "."
  return fileTypes[ext] || "application/octet-stream"; // default if not found
};

export const base64ToBlob = (base64, contentType = "") => {
  const cleanedBase64 = base64.replace(/^data:.*;base64,/, "");
  const byteCharacters = atob(cleanedBase64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
};

export const transformResumeObj = (obj) => {
  const apiData = { ...obj };
  if (apiData.objectid) {
    apiData["objectid_contact@odata.bind"] = apiData.objectid;
    delete apiData.objectid;
  }
  return apiData;
};

export const getInitials = (name = "") =>
  name
    ?.trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase())
    .join("");
